// Create a Firebase Auth account (in the master project) without signing
// out whoever is currently logged in — via a throwaway secondary Firebase
// app instance that's torn down immediately after. Shared by the Admin
// Portal (creating owner/staff logins for any company) and an Owner's own
// Settings > Team tab (creating staff logins for their own company) —
// previously duplicated only in AdminPanel.tsx.
import { initializeApp, deleteApp, getApps } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { masterFirebaseConfig } from '../firebase/master';

export async function createFirebaseAuthUser(email: string, password: string): Promise<string> {
  const tempName = `temp-create-${Date.now()}`;
  const existing = getApps().find(a => a.name === tempName);
  if (existing) await deleteApp(existing);
  const tempApp = initializeApp(masterFirebaseConfig, tempName);
  const tempAuth = getAuth(tempApp);
  try {
    const cred = await createUserWithEmailAndPassword(tempAuth, email, password);
    return cred.user.uid;
  } finally {
    await deleteApp(tempApp);
  }
}
